// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2E_vV","selects":"Documents_selects__F5xgm"};